import FeatureBox from "./FeatureBox";

export default function Feature() {
  return (
    <div className="feature-area de-padding">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 offset-xl-2">
            <div className="site-title text-center">
              <span className="hero-sub-title mb-20">
                <span className="hero-line"></span>
                Features
              </span>
              <h2 className="heading-1">Specialist logistics services</h2>
              <p className="mb-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam
              </p>
            </div>
          </div>
        </div>
        <div className="feature-wpr grid-2">
          <FeatureBox
            imageUrl="https://abbasi-group.com/wp-content/uploads/2020/07/Air-Freight-Forwarding-Banner1.jpg"
            title="Air Freight Services"
            description="When time is the most important factor of your delivery, our Air Freight service is your best option. With our experienced carriers who cover almost the entire world, we are able to deliver your cargo to a destination of your choosing with efficiency and a high level of security. After the quick transit, you’re guaranteed to have your cargo cleared within a matter of hours saving even more time."
          />

          <FeatureBox
            imageUrl="https://abbasi-group.com/wp-content/uploads/2020/07/Ocean-Frieght-Forwarding-Banner1.jpg"
            title="Sea Freight Services"
            description="Lorem ipsum dolor sit amet sed do consectetur adipiscing elit eiusmod tempor incididuntWhen you need to transport a large amount of cargo at a lower cost, our Sea Freight services are your best choice. Endowed with a strong partner network around the globe, we are able to provide you with a wide range of services including Buyer's Consolidation and Multi Country Consolidation. Being strategically located in Sri Lanka enables us to offer efficient, steady and environmentally friendly transport to any destination around the world.

            "
          />

          <FeatureBox
            imageUrl="https://www.cathaybk.com.tw/OVSWS/Content/img/vn/chu-lai/services-card/trade-finance/import-business.jpg"
            title="Logistics Management
            "
            description="We are more than moving cargo from point A to B. In addition to our Freight Forwarding services, we are capable of providing inland logistic services and transportation which makes us a fully integrated supply chain organization. From Country Specific Documentation to Warehouse Management, we will handle all aspects of the delivery process until your cargo reaches its final destination. Not only will this keep your cargo more safe and secure, it will save you both time and money.

            "
          />
          <FeatureBox
            imageUrl="https://tanknewsinternational.com/wp-content/uploads/2019/03/TC-Tank-Containers_9095710_xl-2015.jpg"
            title="Tanktainer Operation"
            description="A fast growing method of transportation around the world, Tanktainers enable safe and secure transfer of bulk liquids and gases from vessel to vessel. By working together with world renowned Tanktainer operators, we have managed to provide you with a cost effective and environmentally friendly way to transport hazardous or non hazardous bulk liquid cargo and food grade."
          />
        </div>
      </div>
    </div>
  );
}
